/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Componente__Z_95_90 as Componente__Z_95_90,
  rec_HorarioMovilidad as HorarioMovilidad,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_SolicitantesMovilidad as SolicitantesMovilidad,
} from "../../runtime/index.jsx";
import { DestinosMovilidad } from "./DestinosMovilidad.jsx";
export function CatalogosMovilidad() {
  let e = (0, ReactCompiler.c)(1),
    t;
  return (
    e[0] === Symbol.for(`react.memo_cache_sentinel`)
      ? ((t = (
          <div
            className={`flex flex-col gap-6`}
            children={[
              <HorarioMovilidad />,
              <SolicitantesMovilidad />,
              <section className={`flex flex-col gap-1`}>
                <h3 className={`text-sm font-medium text-(--text-h)`}>Fundos</h3>
                <p className={`text-xs text-(--text)`}>Desde dónde sale la movilidad. Son los fundos del sistema: se administran en Configuración → Maestros → Fundos, cada uno con su sede (Ica / Pisco).</p>
              </section>,
              <DestinosMovilidad />,
              <Componente__Z_95_90
                titulo={`Áreas`}
                descripcion={`Se pregunta al pedir, después de cuántas personas viajan.`}
                recurso={`areas`}
                nuevoLabel={`Nueva área`}
                placeholder={`SANIDAD`}
              />,
              <Componente__Z_95_90
                titulo={`Horarios de salida`}
                descripcion={`Las horas que se ofrecen al pedir. Se escriben así: 15:30.`}
                recurso={`horarios-salida`}
                nuevoLabel={`Nuevo horario`}
                placeholder={`15:30`}
              />,
            ]}
          />
        )),
        (e[0] = t))
      : (t = e[0]),
    t
  );
}
